import { createAction } from 'redux/helpers/actions';
import types from './types';

export default {
  getContact: (data) => createAction(types.getContact, data),
  updateContact: (data) => createAction(types.updateContact, data),
  storeContact: (data) => createAction(types.storeContact, data),
  deleteContact: (data) => createAction(types.deleteContact, data),
};
